import { Injectable } from '@angular/core';
import { RouterStoreStates } from '@era/stores';
import { Store } from '@ngrx/store';
import { first, map, Observable, tap } from 'rxjs';
import { DeviceActiveSyncsResolverActions } from './device-active-syncs-store/devices-active-syncs.actions';

@Injectable()
export class DeviceActiveSyncCountResolver {
  constructor(
    private readonly activeSyncs: Store<number>,
    private readonly routeStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routeStore.pipe(
      tap(() => {
        this.activeSyncs.dispatch(DeviceActiveSyncsResolverActions.deviceActiveSyncCountRequested());
      }),
      map(() => true),
      first()
    );
  }
}
